import React from 'react';
import { cadenceLegend } from '../../data/howItWorks';
import { cadenceStyles } from './cadenceStyles';
export function CadenceLegend() {
  return <section aria-label="Legend" className="rounded border border-sf-border bg-white px-4 py-3 shadow-card" data-id="element-280" data-mp="206m2k0st20j">
      <h2 className="mb-2 text-xs font-semibold text-sf-weak" data-id="element-281" data-mp="gt0ef6165cmm">Legend — how often each rule is decided</h2>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-282" data-mp="bymgowz1ates">
        {cadenceLegend.map(item => {
        const style = cadenceStyles[item.cadence];
        return <li key={item.cadence} className="flex gap-2" data-id="element-283" data-mp="kv545tohxp3z">
              <span className={`mt-1 h-3 w-3 shrink-0 rounded-sm ${style.solid}`} aria-hidden="true" data-id="element-284" data-mp="zoqicysnwj35" />
              <div data-id="element-285" data-mp="us9so05tdwny">
                <p className={`text-[13px] font-semibold ${style.text}`} data-id="element-286" data-mp="urqdgr7jtmdm">{style.label}</p>
                <p className="text-xs text-sf-weak" data-id="element-287" data-mp="31hofh6th1xtw">{item.description}</p>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}